import { React, useContext } from "react";
import QRCode from "react-qr-code";
import { PageContext } from "../../App";
import { saveFile } from "../Utils";
import Barcode from "react-barcode";
import QRCodeType from "./QRCodeType";

function QRCodeResultView() {
  //get values
  const { qrCodeInputValue } = useContext(PageContext);

  return (
    <div className="container mt-5 border-top pt-5">
      {/* Title */}
      <div className="text-center">
        <label className="text-secondary mb-3">Download QR Code</label>
      </div>
      {/* Can be anything instead of `maxWidth` that limits the width */}
      <div
        className="text-center mx-auto"
        style={{
          height: "auto",
          width: "100%",
        }}
      >
        {/* Qrcode */}
        {qrCodeInputValue.type === QRCodeType.QR_CODE && (
          <QRCode
            id="qr_code"
            size={256}
            style={{ height: "auto", maxWidth: "400px", width: "50%" }}
            value={qrCodeInputValue.value}
            viewBox={`0 0 256 256`}
          />
        )}

        {/* Barcode */}
        {qrCodeInputValue.type === QRCodeType.BARCODE && (
          <Barcode
            value={qrCodeInputValue.value}
            id="barcode"
            displayValue={false}
            style={{ height: "auto", maxWidth: "400px", width: "50%" }}
            className="mx-auto"
          />
        )}

        {/* Code */}
        <div className="text-center mt-3">
          <label className="text-secondary mb-3">
            {qrCodeInputValue.value}
          </label>
        </div>

        {/* Download button */}
        <div className="mt-3 text-center">
          <button
            className="btn btn-success"
            onClick={(e) => {
              //get qrcode element
              const qrElm =
                qrCodeInputValue.type === QRCodeType.QR_CODE
                  ? document.getElementById("qr_code")
                  : document.getElementById("barcode");
              //check
              if (qrElm !== null) {
                //Serialize the SVG element to an XML string
                const serializer = new XMLSerializer();
                //serialize
                let source = serializer.serializeToString(qrElm);

                // Add xmlns attribute if it's missing
                if (
                  !source.match(
                    /^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/
                  )
                ) {
                  source = source.replace(
                    /^<svg/,
                    '<svg xmlns="http://www.w3.org/2000/svg"'
                  );
                }

                // Create a blob and a download link
                const blob = new Blob([source], {
                  type: "image/svg+xml;charset=utf-8",
                });

                //save
                saveFile(
                  blob,
                  `${
                    qrCodeInputValue.type === QRCodeType.QR_CODE
                      ? "qr_code"
                      : "barcode"
                  }_shiva_pdf.svg`
                );
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-cloud-download me-2"
              viewBox="0 0 16 16"
            >
              <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383" />
              <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z" />
            </svg>
            Download (.svg)
          </button>
        </div>
      </div>
    </div>
  );
}

export default QRCodeResultView;
